import { EventArgs } from 'react-ga';
import { createAction } from 'typesafe-actions';

export enum EventCategory {
  nav = 'nav',
}
export const trackEvent = createAction('UI_ANALYTICS/EVENT_TRACK', (resolve) => {
  return (payload: EventArgs & { category: EventCategory }) => resolve(payload);
});
